"use client"

import { useState } from "react";
import { RatesProductByURLType } from "../product";
import StarRatingComponent from "./StarRating";

const RateList = ({ rates }: { rates: RatesProductByURLType[] }) => {

    const [ratings, setRatings] = useState<RatesProductByURLType[]>(rates);

    const handleRatingChange = (id: number, newRating: number) => {
        const updatedRatings = ratings.map(rate => {
            if (rate.id === id) {
                return { ...rate, rate_rate: newRating };
            }
            return rate;
        });
        setRatings(updatedRatings);
    };

    return (
        <div className="space-y-4">
            {ratings.map(rate => (
                <StarRatingComponent key={rate.id} rate={rate} onUpdate={handleRatingChange} />
            ))}
        </div>
    )
}

export default RateList